import React from 'react';
import { createRoot } from 'react-dom/client';
import providerHOC from 'app/utils/providerHOC/providerHOC';
import GlobalMessagesService from './globalMessagesService';
import { getGlobalMessagesRoot } from './globalMessagesUtils';

const GlobalMessagesRoot = providerHOC()(GlobalMessagesService);

createRoot(getGlobalMessagesRoot()).render(<GlobalMessagesRoot />);
